import { supabase } from '../lib/supabase';

export const paymentService = {
  async createJobPaymentIntent(jobId, postingType, employerInfo) {
    try {
      const { data, error } = await supabase?.functions?.invoke('create-job-payment-intent', {
        body: {
          jobId,
          postingType,
          employerInfo
        }
      });

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error creating payment intent:', error);
      throw error;
    }
  },

  async confirmJobPayment(paymentIntentId) {
    try {
      const { data, error } = await supabase?.functions?.invoke('confirm-job-payment', {
        body: { paymentIntentId }
      });

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error confirming payment:', error);
      throw error;
    }
  },

  formatAmount(amount, currency = 'INR') {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })?.format(amount);
  },

  getPostingTypePrices() {
    return {
      standard: 0,
      featured: 999,
      premium: 2499
    };
  },

  getPostingTypeDetails() {
    return {
      standard: {
        name: 'Standard Posting',
        price: 0,
        features: [
          'Basic job listing',
          'Appears in search results',
          'Valid for 30 days',
          'Email notifications'
        ],
        recommended: false
      },
      featured: {
        name: 'Featured Posting',
        price: 999,
        features: [
          'Highlighted in search results',
          'Priority placement',
          'Featured badge',
          'Extended visibility',
          'All Standard features'
        ],
        recommended: true
      },
      premium: {
        name: 'Premium Posting',
        price: 2499,
        features: [
          'Top placement in results',
          'Homepage featured section',
          'Social media promotion',
          'Candidate recommendations',
          'All Featured features'
        ],
        recommended: false
      }
    };
  }
};